import cn from "classnames";
import BookShow from "components/shared/book/show";
import { paths } from "helpers/paths";
import { viewContainer } from "helpers/redux";
import React from "react";
import { applyDocumentNumberSettings, getDocumentNumberSettings } from "sources/documentNumberSettings";

import { buildPreview, documentNumberSettingsConfig, initialState, prefixAllowedCharsRegExp } from "./config";

const DocumentNumberPreview = ({ data }) => (
    <div className="alert alert-secondary py-2 w-100">
        <div className="text-muted">Итоговый следующий номер</div>
        <div className="font-weight-bold">{data.nextNumberPreview || buildPreview(data)}</div>
    </div>
);

const SaveButton = ({ disabled, onClick }) => {
    const cname = cn("btn btn-brand btn-sm", { disabled });

    return (
        <div className="panel__row panel__row--button">
            <button type="button" className={cname} disabled={disabled} onClick={onClick}>
                Сохранить
            </button>
        </div>
    );
};

class DocumentNumberSettings extends BookShow {
    componentDidMount() {
        const initial = this.props.initialState;
        this.setState({ data: initial, initial });
        this.getItem();
    }

    get dropdActions() {
        return [];
    }

    getItem = () => {
        getDocumentNumberSettings()
            .then((settings) => this.applyLoadedSettings(settings || {}))
            .catch(() => this.applyLoadedSettings(null));
    };

    applyLoadedSettings = (data) => {
        this.setState({
            data,
            initial: data,
            isLoading: false,
            isValid: true,
            shouldUpdate: false,
        });
    };

    setValue = ({ name, value }) => {
        const nextValue =
            name === "nextNumber"
                ? value.replace(/\D/g, "").slice(0, 6)
                : value.replace(prefixAllowedCharsRegExp, "").slice(0, 2);

        const { data, initial } = this.state;
        const nextData = { ...data, [name]: nextValue };
        const shouldUpdate = ["infoBasePrefix", "organizationPrefix", "nextNumber"].some(
            (key) => initial[key] !== nextData[key],
        );
        nextData.nextNumberPreview = shouldUpdate ? buildPreview(nextData) : initial.nextNumberPreview;

        const isValid = this.isValidForm(nextData);
        this.setState({ data: nextData, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    saveSettings = () => {
        const data = this.state.data;
        this.setState({ isLoading: true, isValid: true });

        return applyDocumentNumberSettings({
            infoBasePrefix: data.infoBasePrefix,
            organizationPrefix: data.organizationPrefix,
            nextNumber: Number(data.nextNumber),
        })
            .then((res) => {
                if (!res) {
                    this.setState({ isLoading: false, isValid: false });
                    return false;
                } else {
                    this.setState(({ data }) => ({
                        isLoading: false,
                        initial: data,
                        shouldUpdate: false,
                    }));
                    return true;
                }
            })
            .catch(() => {
                this.setState({ isLoading: false });
                return false;
            });
    };

    apply = () => {
        const { data, isLoading, shouldUpdate } = this.state;

        if (isLoading || !shouldUpdate) {
            return null;
        }

        if (!this.isValidForm(data)) {
            this.setState({ isValid: false });
            return null;
        }

        const preview = data.nextNumberPreview || buildPreview(data);

        return this.props.modal({
            name: "confirm",
            title: "Подтвердите сохранение",
            text: (
                <div>
                    <div>Следующий номер будет изменен на:</div>
                    <div className="font-weight-bold mt-2">{preview}</div>
                </div>
            ),
            buttons: { confirm: "Сохранить", cancel: "Отменить" },
            action: this.saveSettings,
        });
    };

    renderBody = () => {
        const { data, isLoading, shouldUpdate } = this.state;
        const disabled = !shouldUpdate || isLoading;
        if (isLoading) {
            return <div className="loading" />;
        }
        return (
            <>
                {this.renderField(documentNumberSettingsConfig.infoBasePrefix)}
                {this.renderField(documentNumberSettingsConfig.organizationPrefix)}
                {this.renderField(documentNumberSettingsConfig.nextNumber)}
                <DocumentNumberPreview data={data} />
                <SaveButton disabled={disabled} onClick={this.apply} />
            </>
        );
    };
}

const ConfiguredShow = (props) => (
    <div className="page-content">
        <DocumentNumberSettings
            {...props}
            back={() => props.history.push(paths.root)}
            config={documentNumberSettingsConfig}
            initialState={initialState}
            title="Настройка нумерации"
            transition="full"
        />
    </div>
);

export default viewContainer(ConfiguredShow, "document-number-settings");
